import { gql } from '@apollo/client';

export const FILTERED_DECLARATIONS = gql`
  query FilteredDeclarations($input: DeclarationFilterArgs!) {
    declarations: filteredDeclarations(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          createdAt
          updatedAt

          published
          text
          title
          version

          createdBy {
            id
            firstName
            lastName
          }
          modifiedBy {
            id
            firstName
            lastName
          }
          portal {
            id
            name
          }
        }
      }
    }
  }
`;
